import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "message-rating-star" }
const _hoisted_2 = { class: "rating-head-tail" }
const _hoisted_3 = { class: "rating-card" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-wrapper" }
const _hoisted_6 = { style: {"max-width":"200px"} }
const _hoisted_7 = ["onClick", "onMouseenter"]
const _hoisted_8 = { style: { marginTop: 10 + 'px', marginBottom: 10 + 'px', wordBreak: 'normal' } }
const _hoisted_9 = { class: "hidden-desc" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "rating-head-tail",
  style: {
        marginTop: 20 + 'px',
      }
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString($setup.props.ratingTemplate.head), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString($setup.TUITranslateService.t("AIDesk.请对本次服务进行评价")), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.starList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              style: {"display":"inline-block"},
              onClick: ($event: any) => ($setup.setValue(index)),
              onMouseenter: ($event: any) => ($setup.setHoverValue(index)),
              onMouseleave: _cache[0] || (_cache[0] = ($event: any) => ($setup.setHoverValue(-1)))
            }, [
              (item === 1)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    src: $setup.star,
                    width: "25px",
                    height: "25px"
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock(_component_Icon, {
                    key: 1,
                    src: $setup.starLine,
                    width: "25px",
                    height: "25px"
                  }, null, 8, ["src"]))
            ], 40, _hoisted_7))
          }), 128))
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_8, _toDisplayString($setup.hoverValue === -1
              ? $setup.value === -1
                ? $setup.TUITranslateService.t("AIDesk.如果满意请给好评哦～")
                : $setup.desc[$setup.value]
              : $setup.desc[$setup.hoverValue]), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString($setup.TUITranslateService.t("AIDesk.如果满意请给好评哦～")), 1)
      ]),
      _createElementVNode("button", {
        class: "submit-button",
        disabled: $setup.hasReply || $setup.hasExpire,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.submitRatingStar && $setup.submitRatingStar(...args)))
      }, _toDisplayString($setup.TUITranslateService.t("AIDesk.提交评价")), 9, _hoisted_10)
    ]),
    ($setup.hasReply)
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString($setup.props.ratingTemplate.tail), 1))
      : _createCommentVNode("", true)
  ]))
}